import { RouteObject } from "react-router-dom";
import { PageNotFound } from "../app/404";
import { LandingPage } from "../app/_website";
import { BlogPage } from "../app/_website/blog";
import { BlogArticlePage } from "../app/_website/blog/[slug]";
import { FindEventsPage } from "../app/_website/find-events";
import {
  AboutPage,
  CareersPage,
  ContactPage,
  HelpCenterPage,
} from "../app/_website/info";
import { PricingPage } from "../app/_website/pricing";
import { ErrorPage } from "../app/error";
import { PreviewSingleEvent } from "../app/events/preview";
import { LegalPage } from "../app/legal";
import { Layout } from "../components/layout/layout";

export const websiteRouter: RouteObject[] = [
  {
    path: "/",
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        path: "",
        element: (
          <Layout>
            {({ isSignedIn, navbarHeight }) => (
              <LandingPage isSignedIn={isSignedIn} navbarHeight={navbarHeight} />
            )}
          </Layout>
        ),
      },
      {
        path: "find-events",
        element: (
          <Layout>
            {({
              navbarHeight,
              pageScrollProgress,
              mobileSearchOpen,
              toggleMobileSearch,
            }) => (
              <FindEventsPage
                navbarHeight={navbarHeight}
                pageScrollProgress={pageScrollProgress}
                mobileSearchOpen={mobileSearchOpen}
                toggleMobileSearch={toggleMobileSearch}
              />
            )}
          </Layout>
        ),
      },
      {
        path: "pricing",
        element: <Layout>{() => <PricingPage />}</Layout>,
      },
      {
        path: "help-center",
        element: <Layout>{() => <HelpCenterPage />}</Layout>,
      },
      {
        path: "contact",
        element: <Layout>{() => <ContactPage />}</Layout>,
      },
      {
        path: "about",
        element: <Layout>{() => <AboutPage />}</Layout>,
      },
      {
        path: "careers",
        element: <Layout>{() => <CareersPage />}</Layout>,
      },
      {
        path: "blog",
        element: <Layout>{() => <BlogPage />}</Layout>,
      },
      {
        path: "blog/:blogSlug",
        element: <Layout>{() => <BlogArticlePage />}</Layout>,
      },
      {
        path: "legal/:doc",
        element: (
          <Layout footerClassName="mt-10">
            {({ navbarHeight }) => (
              <LegalPage
                className="max-width-website"
                navbarHeight={navbarHeight}
              />
            )}
          </Layout>
        ),
      },
      {
        path: "404",
        element: (
          <Layout>
            {() => (
              <div className="max-width-website flex min-h-[70vh] items-center pt-20">
                <PageNotFound />
              </div>
            )}
          </Layout>
        ),
      },
      {
        path: ":slug",
        element: (
          <Layout footerClassName="hidden md:block">
            {({ navbarHeight }) => (
              <div
                className="w-full bg-[linear-gradient(180deg,#D5E9FC_-45.24%,#F4F7FA_26.03%)]"
                style={{ marginTop: -navbarHeight, paddingTop: navbarHeight }}
              >
                <div className="max-width-website py-10">
                  <PreviewSingleEvent canBuy doHoldTicket={false} />
                </div>
              </div>
            )}
          </Layout>
        ),
      },
      {
        path: ":slug/:source",
        element: (
          <Layout footerClassName="hidden md:block">
            {({ navbarHeight }) => (
              <div
                className="w-full bg-[linear-gradient(180deg,#D5E9FC_-45.24%,#F4F7FA_26.03%)]"
                style={{ marginTop: -navbarHeight, paddingTop: navbarHeight }}
              >
                <div className="max-width-website py-10">
                  <PreviewSingleEvent canBuy doHoldTicket={false} />
                </div>
              </div>
            )}
          </Layout>
        ),
      },
      {
        path: ":slug/:source/:tikketPurchaseSessionId",
        element: (
          <Layout footerClassName="hidden md:block">
            {({ navbarHeight }) => (
              <div
                className="w-full bg-[linear-gradient(180deg,#D5E9FC_-45.24%,#F4F7FA_26.03%)]"
                style={{ marginTop: -navbarHeight, paddingTop: navbarHeight }}
              >
                <div className="max-width-website py-10">
                  <PreviewSingleEvent canBuy doHoldTicket={false} />
                </div>
              </div>
            )}
          </Layout>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <Layout>
        {() => (
          <div className="max-width-website flex min-h-[70vh] items-center pt-20">
            <PageNotFound />
          </div>
        )}
      </Layout>
    ),
  },
];
